import { RawEnclave, Enclave } from '../../../types/enclave';

import { ApiMapper } from './types';

const enclaveMapper: ApiMapper<RawEnclave, Enclave> = {
  mapFromApi: (rawEnclave) => ({
    accessType: rawEnclave.maximumAccess,
    description: rawEnclave.description,
    // `iconUrl` was originally used only for marketplace tiles and was not fit for source enclaves.
    // iconUrl: rawEnclave.iconUrl,
    // `iconUrl` only uses the SVG URL for sources in workflows.
    iconUrl: rawEnclave.iconSvgUrl,
    id: rawEnclave.id,
    name: rawEnclave.name,
    type: rawEnclave.label,
    workflowSupported: rawEnclave.workflowSupported,
  }),
};

export default enclaveMapper;
